import React, { StrictMode } from 'react'
import ReactDOM from 'react-dom'
import './style.css'
import Button from './components/buttons.jsx'


const App = () => {
  return (
    <>
    <StrictMode>
      <Button></Button>
    </StrictMode>
    </>
  )
}

export default App
